import { resetHubFiltersVar } from "./hubFiltersVar"
import { resetJobFiltersStateVar } from "./jobs"

const resetStateVars = () => {
  resetJobFiltersStateVar()
  resetHubFiltersVar()
}

export { resetStateVars }
